<template>
    <form @change="sendDataForSaving">
        <div class="row">
            <ValidationProvider
                name="High School"
                rules="latinAndNumbers|min:2|max:500"
                v-slot="{ errors }"
                class="col-md-12"
            >
                <div class="form-group form-group-1">
                    <label for="" class="form-label">High School</label>
                    <textarea
                        type="text"
                        class="form-control"
                        v-model="form.high_school"
                    ></textarea>
                    <FormError :error="errors[0]" name="High School"></FormError>
                </div>
            </ValidationProvider>

            <div class="col-md-6">
                <div class="form-group form-group-1">
                    <label for="" class="form-label">Graduated</label>
                    <div class="buttons-type-multiselect two-btns">
                        <div class="item">
                            <input
                                type="radio"
                                name="school"
                                class="rad"
                                id="12"
                                value="1"
                                v-model="form.high_school_graduated"
                            >
                            <label for="12">
                                <div class="ttl">Yes</div>
                            </label>
                        </div>
                        <div class="item">
                            <input
                                type="radio"
                                name="school"
                                class="rad"
                                id="13"
                                value="0"
                                v-model="form.high_school_graduated"
                            >
                            <label for="13">
                                <span class="ttl">No</span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="wrap-border-top">
            <div class="row">

                <ValidationProvider
                    name="College education"
                    rules="latinAndNumbers|min:2|max:500"
                    v-slot="{ errors }" class="col-md-12"
                >
                    <div class="form-group form-group-1">
                        <label for="" class="form-label">College</label>
                        <textarea
                            type="text"
                            class="form-control"
                            v-model="form.college"
                        ></textarea>
                        <FormError :error="errors[0]" name="College education"></FormError>
                    </div>
                </ValidationProvider>

                <div class="col-md-6">
                    <div class="form-group form-group-1">
                        <label for="" class="form-label">Graduated</label>
                        <div class="buttons-type-multiselect two-btns">
                            <div class="item">
                                <input
                                    type="radio"
                                    name="college"
                                    class="rad"
                                    id="122"
                                    value="1"
                                    v-model="form.college_graduated"
                                >
                                <label for="122">
                                    <div class="ttl">Yes</div>
                                </label>
                            </div>
                            <div class="item">
                                <input
                                    type="radio"
                                    name="college"
                                    class="rad"
                                    id="133"
                                    value="0"
                                    v-model="form.college_graduated"
                                >
                                <label for="133">
                                    <span class="ttl">No</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                <ValidationProvider
                    name="College diploma"
                    v-slot="{ errors }"
                    rules="latinAndNumbers|min:2|max:300"
                    class="col-lg-12"
                >
                    <div class="form-group form-group-1">
                        <label for="" class="form-label">Diploma or Degree</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="form.college_diploma"
                        >
                        <FormError :error="errors[0]" name="College diploma"></FormError>
                    </div>
                </ValidationProvider>

            </div>
        </div>
        <div class="wrap-border-top">
            <div class="row">
                <ValidationProvider
                    name="Professional school"
                    rules="latinAndNumbers|min:2|max:500"
                    v-slot="{ errors }"
                    class="col-md-12"
                >
                    <div class="form-group form-group-1">
                        <label for="" class="form-label">Trade or professional school</label>
                        <textarea
                            type="text"
                            class="form-control"
                            v-model="form.prof_school"
                        ></textarea>
                        <FormError :error="errors[0]" name="Professional school"></FormError>
                    </div>
                </ValidationProvider>

                <div class="col-md-6">
                    <div class="form-group form-group-1">
                        <label for="" class="form-label">Graduated</label>
                        <div class="buttons-type-multiselect two-btns">
                            <div class="item">
                                <input
                                    type="radio"
                                    name="prof-school"
                                    class="rad"
                                    id="id-1222"
                                    value="1"
                                    v-model="form.prof_school_graduated"
                                >
                                <label for="id-1222">
                                    <div class="ttl">Yes</div>
                                </label>
                            </div>
                            <div class="item">
                                <input
                                    type="radio"
                                    name="prof-school"
                                    class="rad"
                                    id="id-1333"
                                    value="0"
                                    v-model="form.prof_school_graduated"
                                >
                                <label for="id-1333">
                                    <span class="ttl">No</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                <ValidationProvider
                    name="Professional school diploma"
                    rules="latinAndNumbers|min:2|max:300"
                    v-slot="{ errors }"
                    class="col-lg-12"
                >
                    <div class="form-group form-group-1">
                        <label for="" class="form-label">Diploma or Degree</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="form.prof_school_diploma"
                        >
                        <FormError :error="errors[0]" name="Professional school diploma"></FormError>

                    </div>
                </ValidationProvider>
            </div>
        </div>
        <div class="wrap-border-top" v-if="showInputName">
            <div>
                <ValidationProvider
                    class="col-lg-12"
                    name="Agree"
                    rules="required"
                    v-slot="{ errors }"
                >
                    <div class="form-group form-group-1">
                        <div class="form-check">
                            <input
                                class="form-check-input-checkbox"
                                type="checkbox"
                                name="name312"
                                id="privacy"
                                value="1"
                                v-model="form.person_agree"
                            >
                            <label class="form-check-label" for="privacy">
                                <p>I agree to give ORNA two weeks notice when I <b>resign or accept any final monies due at minimum
                                    wage</b></p>
                            </label>
                            <FormError :error="errors[0]" name="Agree" class="ml-3"></FormError>
                        </div>
                    </div>
                </ValidationProvider>
            </div>
        </div>
    </form>
</template>

<script>

import PrivacyPolicy from "../../../../../../resources/js/components/PrivacyPolicy.vue";

export default {
    name: 'EducationForm',
    components: {PrivacyPolicy},
    props: {
        user: {
            type: Object
        }
    },
    emits: ['data-changed'],
    data() {
        return {
            form: {
                high_school: null,
                high_school_graduated: null,
                college: null,
                college_graduated: null,
                college_diploma: null,
                prof_school: null,
                prof_school_graduated: null,
                prof_school_diploma: null,
                person_agree: null,
            },
        }
    },
    computed: {
        showInputName() {
            if (window.location.pathname === '/application-step-8') {
                return true
            }
        }
    },
    methods: {
        sendDataForSaving() {
                this.$emit('data-changed', this.form);
        },
        setData() {
            for (const userKey in this.user.education_details) {
                for (const formKey in this.form) {
                    if (userKey === formKey) {
                        this.form[userKey] = this.user.education_details[formKey];
                    }
                }
            }
        },
    },
    mounted() {
        this.setData();
        this.form.person_agree = false
    }

}

</script>

<style scoped>

</style>
